module.exports = __webpack_public_path__ + "img/item1.79298794.png";